import BaseTableView from "../../../longhudou/module/table/base_table_view";
import Util from "../../../longhudou/module/util";
import LanguageManager from "../../../../manager/language_manager";
import BJLEffectCtr, { EffectName } from "../bjl_effect_ctr";
import BJLSoundCtr from "../bjl_sound_ctr";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
const { ccclass, property } = cc._decorator;

@ccclass
export default abstract class BJLTableView extends BaseTableView {
    @property(cc.Label)
    xianWinLab:cc.Label = null

    @property(cc.Label)
    zhuanWinLab:cc.Label = null

    @property(cc.Label)
    heWinLab:cc.Label = null

    @property(cc.Label)
    xianDuiLab:cc.Label = null

    @property(cc.Label)
    zhuanDuiLab:cc.Label = null

    @property(cc.Label)
    allCountLab:cc.Label = null

    @property(cc.Label)
    resultXian:cc.Label = null

    @property(cc.Label)
    resultZhuan:cc.Label = null

    @property(cc.Label)
    resultBigXian:cc.Label = null

    @property(cc.Label)
    resultBigZhuan:cc.Label = null

    @property(cc.Sprite)
    lastPlayer:cc.Sprite[] = []

    @property(cc.Sprite)
    lastBanker:cc.Sprite[] = []

    @property(SpriteFrameHolder)
    xiaSanLuSpriteHolder:SpriteFrameHolder = null

    @property(cc.Sprite)
    pokerNoAmin:cc.Sprite[] = []

    @property(cc.Node)
    resultNode:cc.Node = null



    bjlSoundCtr:BJLSoundCtr = new BJLSoundCtr()
    bjlEffectCtr = null
    betAreaType = {
        Xian : "1",
        Zhuan: "2",
        He: "3",
        XianDui: "4",
        ZhuanDui: "5",
    }

    onLoad(){
        super.onLoad()
        this.paiBeiName = "Public_pukepaibei"
        this.bjlEffectCtr = this.effectCtr as BJLEffectCtr
    }

    start(){
        super.start()
        this.bjlSoundCtr.playBgm()
    }

    refreshSelectRoadMap(roadMapDatas){
        super.refreshSelectRoadMap(roadMapDatas)
        this.updateResultCount(this.roadMapDatas)
    }

    //显示开奖结果 this.resultPokers 前6为庄牌  后6位闲牌
    showResulet(resuletData: any, m_callback:Function, isAmin:boolean = true){
        if (resuletData == null){ return }
        if (!isAmin){
            this.showResultNoAmin(resuletData, m_callback)
            return
        }
        let self = this
        let xianTwo = 0
        let zhuanTwo = 0
        for (let index = 0; index < 3; index++) {
            if (index <= 1){
                xianTwo =  xianTwo + (resuletData.playerCards[index].number >= 10 ? 0 : resuletData.playerCards[index].number)
                zhuanTwo = zhuanTwo + (resuletData.bankerCards[index].number >= 10 ? 0 : resuletData.bankerCards[index].number)
            }
            let  playerData = Util.getBjlImageNameFromCard(resuletData.playerCards[index])
            let  bankerData = Util.getBjlImageNameFromCard(resuletData.bankerCards[index])
            //设置庄的牌
            this.resultPokers[index].spriteFrame = this.pokerAtlas.getSpriteFrame(bankerData)
            this.resultPokers[index + 3].spriteFrame = this.pokerAtlas.getSpriteFrame(bankerData)
            //设置闲的牌
            this.resultPokers[index + 6].spriteFrame = this.pokerAtlas.getSpriteFrame(playerData) 
            this.resultPokers[index + 9].spriteFrame = this.pokerAtlas.getSpriteFrame(playerData)
        }
        this.resultNode.active = true

        //cc.log("=========STARTFuck=========", Date.parse(new Date().toString()))
        //播放完成所有的
        let playOver = function(){
            self.bjlSoundCtr.playerWin(resuletData.result.result)
            if (resuletData.result.result != 3){
                let effType = resuletData.result.result == 1 ? EffectName.PlayerWin : EffectName.BankerWin
                self.bjlEffectCtr.playEffectAnim(effType, ()=>{}, null, true)
            }
            else{
                self.bjlEffectCtr.playEffectAnim(EffectName.HeWin, ()=>{}, null, true)
            }
            if (m_callback != null){
                m_callback()
            }
            //cc.log("=========ENDFuck=========", Date.parse(new Date().toString()))
            self.scheduleOnce(()=>{
                self.bjlEffectCtr.playerWin.node.active = false
                self.bjlEffectCtr.bankerWin.node.active = false
                self.bjlEffectCtr.heWin.node.active = false
                self.bjlEffectCtr.clearPokers()
                self.resultBigXian.string = ""
                self.resultBigZhuan.string = ""
                self.bjlEffectCtr.playEffectAnim(EffectName.ResultEnd)
                self.scheduleOnce(()=>{
                    self.resultNode.active = false
                    
                }, 1)
            }, 2)

        }


        //播放庄家第三张牌
        let showBankerThreePoker = function(){
            self.scheduleOnce(()=>{
                //庄家需要补牌
                if (resuletData.bankerCards.length >= 3){
                    self.bjlSoundCtr.playBuPai(true, null)
                   self.scheduleOnce(()=>{
                    //self.leftPokerCount.string = (Number(self.leftPokerCount.string) + 1).toString()
                    self.rightPokerCount.string = (Number(self.rightPokerCount.string) - 1).toString()
                    self.bjlEffectCtr.bankerLine.active = true
                    self.bjlEffectCtr.playEffectAnim(EffectName.FaPaiBank, ()=>{}, null, true)
                    let node1 = self.bjlEffectCtr.pokerAmin[1].node
                    let node2 = self.bjlEffectCtr.pokerAmin[3].node
                    let newPos1 = new cc.Vec2(node1.position.x - 100, node1.position.y)
                    let newPos2 = new cc.Vec2(node2.position.x - 100, node2.position.y)
                    let newPos3 = new cc.Vec2(self.bjlEffectCtr.bankerDuizi.node.position.x - 100, self.bjlEffectCtr.bankerDuizi.node.position.y)
                    self.moveToPos(node1.position, newPos1, node1, null, 0.2)
                    self.moveToPos(node2.position, newPos2, node2, null, 0.2)
                    self.moveToPos(self.bjlEffectCtr.bankerDuizi.node.position, newPos3, self.bjlEffectCtr.bankerDuizi.node, null, 0.2)
                    self.bjlSoundCtr.playFanPai()
                    self.bjlEffectCtr.playPokerListByIndex(5, ()=>{
                        zhuanTwo = (resuletData.bankerCards[2].number >= 10 ? 0 : resuletData.bankerCards[2].number) + zhuanTwo
                        let zhuanCount = (zhuanTwo % 10).toString()
                        self.resultZhuan.string = zhuanCount
                        self.resultBigZhuan.string = zhuanCount
                        self.bjlSoundCtr.playDianShu(Number(zhuanCount))
                        self.scheduleOnce(()=>{
                            playOver()
                        }, 0.76)
                    })
                   }, 1.55)
                }
                else{
                    playOver()
                }
            }, 0.3)
        }

        //播放闲家第三张牌
        let showPlayerThreePoker = function(){
            self.scheduleOnce(()=>{
                //闲家需要补牌
                if (resuletData.playerCards.length >= 3){
                    self.bjlSoundCtr.playBuPai(false, null)
                    self.scheduleOnce(()=>{
                        //self.leftPokerCount.string = (Number(self.leftPokerCount.string) + 1).toString()
                        self.rightPokerCount.string = (Number(self.rightPokerCount.string) - 1).toString()
                        self.bjlEffectCtr.playerLine.active = true
                        self.bjlEffectCtr.playEffectAnim(EffectName.FaPaiPlayer, ()=>{}, null, true)
                        let node1 = self.bjlEffectCtr.pokerAmin[0].node
                        let node2 = self.bjlEffectCtr.pokerAmin[2].node
                        let newPos1 = new cc.Vec2(node1.position.x - 100, node1.position.y)
                        let newPos2 = new cc.Vec2(node2.position.x - 100, node2.position.y)
                        let newPos3 = new cc.Vec2(self.bjlEffectCtr.playerDuizi.node.position.x - 100, self.bjlEffectCtr.playerDuizi.node.position.y)
                        self.moveToPos(node1.position, newPos1, node1, null, 0.2)
                        self.moveToPos(node2.position, newPos2, node2, null, 0.2)
                        self.moveToPos(self.bjlEffectCtr.playerDuizi.node.position, newPos3, self.bjlEffectCtr.playerDuizi.node, null, 0.2)
                        self.bjlSoundCtr.playFanPai()
                        self.bjlEffectCtr.playPokerListByIndex(4, ()=>{
                            xianTwo = (resuletData.playerCards[2].number >= 10 ? 0 : resuletData.playerCards[2].number) + xianTwo
                            let xianCount =  (xianTwo % 10).toString()
                            self.resultXian.string = xianCount
                            self.resultBigXian.string = xianCount
                            self.bjlSoundCtr.playDianShu(Number(xianCount))
                            self.scheduleOnce(()=>{
                                showBankerThreePoker()
                            }, 0.76)
                        })
                    }, 1.5)
                }
                else{
                    showBankerThreePoker()
                }
            }, 0.3)

        }


        //播放庄家第二张牌
        let playBankerDianshu = function(){
            //庄家播放完两张牌需要等待播放对子 点数等等音效
            self.scheduleOnce(()=>{
                let zhuanCount = (zhuanTwo % 10).toString() 
                self.resultZhuan.string = zhuanCount
                self.resultBigZhuan.string = zhuanCount
                
                if (!resuletData.result.bankerPair){
                    self.bjlSoundCtr.playDianShu(Number(zhuanCount))
                    self.scheduleOnce(()=>{
                        showPlayerThreePoker()
                    }, 0.76)
                }
                else{
                    self.bjlEffectCtr.playEffectAnim(EffectName.BankerDuizi,  ()=>{}, null, true)
                    self.bjlSoundCtr.playDuizi(true, ()=>{self.bjlSoundCtr.playDianShu(Number(zhuanCount))})
                    self.scheduleOnce(()=>{
                        showPlayerThreePoker()
                    }, 1.9)
                }
            }, 0.3)
        }

        //闲庄家播放两张牌后
        let playTwoResultSound = function(){
            let xianCount =  (xianTwo % 10).toString()
            self.resultXian.string = xianCount
            self.resultBigXian.string = xianCount
            if (!resuletData.result.playerPair){
                self.bjlSoundCtr.playDianShu(Number(xianCount))
                self.scheduleOnce(()=>{
                    playBankerDianshu()
                }, 0.76)
            }
            else{
                self.bjlEffectCtr.playEffectAnim(EffectName.PlayerDuizi, ()=>{}, null, true)
                self.bjlSoundCtr.playDuizi(false, ()=>{ self.bjlSoundCtr.playDianShu(Number(xianCount))})
                self.scheduleOnce(()=>{
                    playBankerDianshu()
                }, 1.96)
            }
            
        }
        this.bjlSoundCtr.playOpenResult()
        this.bjlEffectCtr.playEffectAnim(EffectName.Result, ()=>{}, null, true)
        self.scheduleOnce(()=>{
            //开始播放翻牌
            self.bjlEffectCtr.playEffectAnim(EffectName.FanPai, ()=>{}, null, true)
            self.bjlSoundCtr.playFanPai()
            self.bjlEffectCtr.playPokerListByIndex(0, ()=>{
                self.bjlSoundCtr.playFanPai()
                self.bjlEffectCtr.playPokerListByIndex(1, ()=>{
                    self.bjlSoundCtr.playFanPai()
                    self.bjlEffectCtr.playPokerListByIndex(2, ()=>{
                        self.bjlSoundCtr.playFanPai()
                        self.bjlEffectCtr.playPokerListByIndex(3, ()=>{
                            playTwoResultSound()//闲家播放完两张牌需要等待播放对子 点数等等音效
                        })
                    })
                })
            })
        }, 0.6)


    }

    //直接展示结果 无动画
    showResultNoAmin(resuletData, m_callback){
        if (m_callback!= null){
            m_callback()
        }
        let xianCount = 0
        let zhuanCount = 0
        for (let index = 0; index < 3; index++) {
            if (resuletData.playerCards[index] != null){
                let  playerData = Util.getBjlImageNameFromCard(resuletData.playerCards[index])
                this.pokerNoAmin[index].spriteFrame = this.pokerAtlas.getSpriteFrame(playerData)
                this.pokerNoAmin[index].node.active = true
                xianCount =  xianCount + (resuletData.playerCards[index].number >= 10 ? 0 : resuletData.playerCards[index].number)
                
            }
            if (resuletData.bankerCards[index] != null){
                let  bankerData = Util.getBjlImageNameFromCard(resuletData.bankerCards[index])
                this.pokerNoAmin[index + 3].spriteFrame = this.pokerAtlas.getSpriteFrame(bankerData)
                this.pokerNoAmin[index + 3].node.active = true
                zhuanCount =  zhuanCount + (resuletData.bankerCards[index].number >= 10 ? 0 : resuletData.bankerCards[index].number)
            }
            
        }
        this.resultXian.string = (xianCount%10).toString()
        this.resultZhuan.string = (zhuanCount%10).toString()
    }

    playResultAmin(resuletData, betData, jackpotDataAdd) {
        if (betData == null || resuletData == null){ return }
        this.curWinArea[0] = false
        this.curWinArea[this.betAreaType.XianDui] = resuletData.result.playerPair
        this.curWinArea[this.betAreaType.ZhuanDui] = resuletData.result.bankerPair
        this.curWinArea[resuletData.result.result.toString()] = true
        super.playResultAmin(resuletData, betData, jackpotDataAdd)
    }

    //获取下注区域
    getAreaByPosMax(area){
        let pos = new cc.Vec2(0,0)
        if (area == 1 || area == 2){
            pos =  this.getRandomPosInRect(140, 100)
        }
        else if (area == 3){
            pos =  this.getRandomPosInRect(200, 30) 
        }
        else{
            pos =  this.getRandomPosInRect(140, 30) 
        }
        return pos
            
    }

    updateResultCount(resultData){
        let allCount = resultData == null?0 : resultData.length 
        let xianDui = 0
        let zhuanDui = 0
        let countTable = []
        for (let index = 0; index < allCount; index++) {
            const element = resultData[index];
            let resKey = element.result.toString()
            countTable[resKey] = countTable[resKey] == null ? 1 : countTable[resKey] + 1
           if (element.bankerPair){
                zhuanDui += 1
           }
           if (element.playerPair){
                xianDui += 1
            }
        }
        this.allCountLab.string = LanguageManager.t("bjl_zonshu") + allCount
        this.xianDuiLab.string = LanguageManager.t("bjl_xiandui")  + xianDui
        this.zhuanDuiLab.string = LanguageManager.t("bjl_zhuandui")  + zhuanDui
        this.xianWinLab.string = LanguageManager.t("bjl_xian")  + (countTable[this.betAreaType.Xian] == null ? 0 : countTable[this.betAreaType.Xian])
        this.zhuanWinLab.string = LanguageManager.t("bjl_zhuan")  + (countTable[this.betAreaType.Zhuan] ==null ? 0 : countTable[this.betAreaType.Zhuan])
        this.heWinLab.string = LanguageManager.t("bjl_he")  + (countTable[this.betAreaType.He] == null ? 0: countTable[this.betAreaType.He])
        let curValue = null
        for(let i =0; i < 3; i++){
            curValue = this.curSelectRoadMap.getForecastState(i, 1)
            if(curValue != null){
                this.lastPlayer[i].spriteFrame =  this.xiaSanLuSpriteHolder.getSpriteFrameByKey(i*2 + curValue) 
            }else{
                this.lastPlayer[i].spriteFrame = null
            }
            
            curValue = this.curSelectRoadMap.getForecastState(i, 2)
            if(curValue != null){
                this.lastBanker[i].spriteFrame =  this.xiaSanLuSpriteHolder.getSpriteFrameByKey(i*2 + curValue) 
            }else{
                this.lastBanker[i].spriteFrame = null
            }
            
        }
    }

    updateTopInfo(roomInfo, curRoomStatus){
        let self = this
        super.updateTopInfo(roomInfo, curRoomStatus)
        switch(roomInfo.state){
            case 0: //上庄动画
                break
            case 1: //开始
                break;
            case 2: //洗牌
                this.bjlEffectCtr.playEffectAnim(EffectName.XiPaiAmin, null, null, null, null, 1)
                break;
            case 3: // 准备
                this.cleanTable()
                this.bigRound.string = roomInfo.round
                break
            case 4: //发牌
                if (curRoomStatus != null){
                    this.bjlEffectCtr.playEffectAnim(EffectName.FaPai)
                    for (let index = 0; index < 4; index++) {
                        self.scheduleOnce(()=>{
                            self.bjlSoundCtr.playFaPai(null)
                        }, index * 0.7)
                        
                    }
                }
                this.betDataByIndex = []
                break
            case 5: //下注
                break
            case 6: //开牌
                break
            case 7: //派奖
                break
            default:
                break;
        }

        if (roomInfo.state >= 4 && curRoomStatus == null && roomInfo.state < 6){
            this.bjlEffectCtr.playEffectAnim(EffectName.FaPaiEnd)
        }

    }

    cleanTable(){
        super.cleanTable()
        this.resultZhuan.string = ""
        this.resultXian.string = ""
        this.resultBigXian.string = ""
        this.resultBigZhuan.string = ""
        this.resultNode.active = false
        this.bjlEffectCtr.bankerFaPai.node.active = false
        this.bjlEffectCtr.playerFaPai.node.active = false
        this.bjlEffectCtr.fapai.node.active = false
        for (const poker of this.resultPokers) {
            poker.node.opacity = 0
        }
        for (const pokerNode of this.pokerNoAmin) {
            pokerNode.node.active = false
        }
        this.bjlEffectCtr.clearPokers()
    }

}